import ReactDOM from 'react-dom'
import "../../scss/style.scss"
import CalendarSVG from "../../../assets/calendar.svg"
import ClockSVG from "../../../assets/clock.svg"
import LocationSVG from "../../../assets/location.svg"

document.addEventListener("DOMContentLoaded", function () {

    const divsToListStyle1Update = document.querySelectorAll(".hw-list-style-1-update-me");
    const divsToInformationUpdate = document.querySelectorAll(".hw-information-update-me")
    const divsToRegisterButtonUpdate = document.querySelectorAll(".hw-register-button-update-me")
    const divsToDescriptionUpdate = document.querySelectorAll(".hw-description-update-me")
    const divsToRegisterFormUpdate = document.querySelectorAll(".hw-register-form-update-me")


    if (divsToListStyle1Update.length > 0) {
        divsToListStyle1Update.forEach(function (div) {

            const apiData = JSON.parse(div.querySelector(".list-style-1-api-data").innerHTML);
            const attributesData = JSON.parse(div.querySelector(".list-style-1-attributes-data").innerHTML);
            const props = Object.assign({}, apiData, attributesData);
            ReactDOM.render(<HWEventListStyle1 {...props}></HWEventListStyle1>, div)
            div.classList.remove("hw-list-style-1-update-me");

        })
        function HWEventListStyle1(props) {
            return (
                <div>
                    {props.data.map(function (event, index) {
                        return (
                            <div className="list-container mt-5" style={{ textAlign: props.theAlignment, backgroundColor: props.bgColor, borderColor: props.borderColor }}>
                                <div className="row">
                                    <div className="col col-md-6">
                                        <img className='list-image' src={event.eventimage}></img>
                                    </div>
                                    <div className='col col-md-6'>
                                        <div className='info-container'>
                                            <div className="event-head" style={{ borderColor: props.borderColor }}>
                                                <h3 className='list-name' style={{ color: props.titleColor, fontSize: props.titleSize }}>{event.title}</h3>
                                                {event.seocostmember1 != 0 ? <p className='list-price' style={{ color: props.textColor, fontSize: props.priceSize }}>Preis: {event.seocostmember1}€</p> : ""}
                                            </div>
                                            <div className="list-info">
                                                <p className='list-description' style={{ color: props.textColor, fontSize: props.descriptionSize }}> {event.description} </p>
                                                <p class="list-date" style={{ color: props.textColor, fontSize: props.dateSize }}><i className='bi bi-calendar-week' style={{ color: props.iconColor }}></i>&nbsp;&nbsp;{dateOrganisator(event.sedatebegin)}</p>
                                                {event.seoaddress.length > 1 ? <p class="list-address" style={{ color: props.textColor, fontSize: props.addressSize }}><i className='bi bi-geo' style={{ color: props.iconColor }}></i>&nbsp;&nbsp;{addressOrganisator(event.seoaddress)}</p> : ""}
                                                <div className="button-container mt-5">
                                                    <a className='btn btn-primary' style={{ background: props.btnColor, color: props.btnTextColor, border: "none", position: 'absolute', bottom: '15px' }} href={event.guid}>Event Details</a>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div >
            )
        }
    }
    if (divsToInformationUpdate.length > 0) {
        divsToInformationUpdate.forEach(function (div) {
            const informationApiData = JSON.parse(div.querySelector(".information-api-data").innerHTML);
            const informationAttributesData = JSON.parse(div.querySelector(".information-attributes-data").innerHTML);
            const propsInformation = Object.assign({}, informationApiData, informationAttributesData);
            ReactDOM.render(<HWInformation {...propsInformation}></HWInformation>, div)
            div.classList.remove("hw-information-update-me");
        })
        function HWInformation(props) {

            return (
                <div>
                    <div className="row">
                        <div className="col-md-12 ">
                            <div className="event-details-container" style={{ backgroundColor: props.attributes.bgColor }}>
                                <div className="row">
                                    <div className="col-md-3 align-self-center">
                                        <img src={CalendarSVG} alt="" className="event-icons" />
                                    </div>
                                    <div className="col-md-9 align-self-center">
                                        <p className="event-details-header" style={{ color: props.attributes.titleColor, fontSize: props.attributes.titleSize }} >Datum</p>
                                        <p className="event-details-description" style={{ color: props.attributes.textColor, fontSize: props.attributes.descriptionSize }}>{dateOrganisator(props.data.sedatebegin)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 ">
                            <div className="event-details-container" style={{ backgroundColor: props.attributes.bgColor }}>
                                <div className="row">
                                    <div className="col-md-3 align-self-center">
                                        <img src={ClockSVG} alt="" className="event-icons" />
                                    </div>
                                    <div className="col-md-9 align-self-center">
                                        <p className="event-details-header" style={{ color: props.attributes.titleColor, fontSize: props.attributes.titleSize }}>Uhrzeit</p>
                                        <p className="event-details-description" style={{ color: props.attributes.textColor, fontSize: props.attributes.descriptionSize }}>08:00 - {props.data.seendtime.substring(0, 5)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {props.data.seoaddress.length > 1 ? <div className="col-md-12 ">
                            <div className="event-details-container" style={{ backgroundColor: props.attributes.bgColor }}>
                                <div className="row">
                                    <div className="col-md-3 align-self-center">
                                        <img src={LocationSVG} alt="" className="event-icons" />
                                    </div>
                                    <div className="col-md-9 align-self-center">
                                        <p className="event-details-header" style={{ color: props.attributes.titleColor, fontSize: props.attributes.titleSize }}>Ort</p>
                                        <p className="event-details-description" style={{ color: props.attributes.textColor, fontSize: props.attributes.descriptionSize }}>{addressOrganisator(props.data.seoaddress)}</p>
                                    </div>
                                </div>
                            </div>
                        </div> : ''}
                    </div>
                </div>
            )
        }
    }
    if (divsToRegisterButtonUpdate.length > 0) {
        divsToRegisterButtonUpdate.forEach(function (div) {
            const registerButtonApiData = JSON.parse(div.querySelector(".register-button-api-data").innerHTML);
            const registerButtonAttributesData = JSON.parse(div.querySelector(".register-button-attributes-data").innerHTML);
            const propsRegisterButton = Object.assign({}, registerButtonApiData, registerButtonAttributesData);
            ReactDOM.render(<HWRegisterButton {...propsRegisterButton}></HWRegisterButton>, div)

            div.classList.remove("hw-register-button-update-me");
        })
        function HWRegisterButton(props) {

            return (
                <div>
                    <div className="button-container">
                        <a href={props.data.page} className="btn btn-primary" style={{ padding: props.attributes.padding, float: props.attributes.theAlignment, backgroundColor: props.attributes.bgColor, color: props.attributes.textColor, fontSize: props.attributes.textSize, border: 'none' }}>Jetzt buchen!</a>
                    </div>
                </div>
            )
        }
    }
    if (divsToDescriptionUpdate.length > 0) {
        divsToDescriptionUpdate.forEach(function (div) {
            const descriptionApiData = JSON.parse(div.querySelector(".description-api-data").innerHTML);
            const descriptionAttributesData = JSON.parse(div.querySelector(".description-attributes-data").innerHTML);
            const descriptionProps = Object.assign({}, descriptionApiData, descriptionAttributesData);
            ReactDOM.render(<HWDescription {...descriptionProps}></HWDescription>, div)
            div.classList.remove("hw-description-update-me");
        })
        function HWDescription(props) {

            return (
                <div>
                    <p>{props.data.description}</p>
                </div>
            )
        }
    }
    if (divsToRegisterFormUpdate.length > 0) {

        divsToRegisterFormUpdate.forEach(function (div) {
            const registerFormApiData = JSON.parse(div.querySelector(".register-form-api-data").innerHTML);
            const registerFormAttributesData = JSON.parse(div.querySelector(".register-form-attributes-data").innerHTML);
            const registerFormProps = Object.assign({}, registerFormApiData, registerFormAttributesData);
            ReactDOM.render(<HWRegisterForm {...registerFormProps}></HWRegisterForm>, div)
            div.classList.remove("hw-register-form-update-me");
        });

        function HWRegisterForm(props) {
            const formControl = () => {
                var control = false;
                var checkboxes = document.getElementsByName('memberships[]')
                if (checkboxes.length > 0) {
                    checkboxes.forEach((item) => {
                        if (item.checked == true) {
                            control = true;
                        }
                    })
                }
                else {
                    control = true;
                }

                console.log('calisti')
                if (document.getElementById("vorname").value.length != 0 &&
                    document.getElementById("nachname").value.length != 0 &&
                    document.getElementById("telefon").value.length != 0 &&
                    document.getElementById("email").value.length != 0 &&
                    document.getElementById("postleitzahl").value.length != 0 &&
                    document.getElementById("ort").value.length != 0 &&
                    document.getElementById("strabe").value.length != 0 &&
                    control == true
                ) {
                    document.getElementById("submit").disabled = false;
                }
                else {
                    document.getElementById("submit").disabled = true;
                }

            }
            return (
                <div>
                    <form method='POST' action={props.data.posturl}>
                        <input type='hidden' name='action' value="add_foobar"></input>
                        <input type="hidden" name="twdocid" id="twdocid" value={props.data.twdocid}></input>
                        <div class="row">
                            <h3 className="hw-register-form-title">Event Anmeldung</h3>
                            <hr className="hw-register-form-hr"></hr>
                            <table className="hw-table">
                                <tr>
                                    <th className="hw-table-title">Event</th>
                                    <th className="hw-table-desc">{props.data.seoheader}</th>
                                </tr>
                                <tr>
                                    <th className="hw-table-title">Datum</th>
                                    {props.data.sedatebegin != props.data.sedateend ?
                                        <th className="hw-table-desc">{dateOrganisator(props.data.sedatebegin) + ' - ' + dateOrganisator(props.data.sedateend)}</th> :
                                        <th className="hw-table-desc">{dateOrganisator(props.data.sedatebegin)}</th>
                                    }
                                </tr>
                                <tr>
                                    <th className="hw-table-title">Uhrzeit</th>
                                    <th className="hw-table-desc">08:00 - {props.data.seendtime.substring(0, 5)}

                                    </th>
                                </tr>
                                <tr>
                                    <th className="hw-table-title">Ort</th>
                                    <th className="hw-table-desc">{addressOrganisator(props.data.seoaddress)}</th>
                                </tr>
                            </table>

                            {props.data.memberships.length > 0 ? <div className="row">
                                <h4 className="hw-table-subtitle">Ich bin:</h4>
                                <div className="col-md-12">
                                    {props.data.memberships.map((membership, i) => {
                                        if (membership.length > 2) {

                                            const type = membership.split("|")[0];
                                            const price = membership.split("|")[1];
                                            const onlyOne = (target) => {
                                                var checkboxes = document.getElementsByName('memberships[]')
                                                checkboxes.forEach((item) => {
                                                    if (item !== target) item.checked = false
                                                })
                                                formControl();
                                            }


                                            return (
                                                <div className="form-group">
                                                    <input className="form-control form-check-input hw-checkbox hw-form-control" type="checkbox" name='memberships[]' value={membership} onClick={((e) => onlyOne(e.target))} />
                                                    <label className="hw-form-label form-check-label" for="Land" style={{ width: "30%" }}> {type}</label>
                                                    <label className="hw-form-label form-check-label" for="Land"> Teilnehmerbeitrag&nbsp;&nbsp;&nbsp;{price}€</label>
                                                </div>
                                            )
                                        }
                                    })}
                                </div>
                            </div> : ''}


                            <h4 className="hw-table-subtitle">Teilnehmer</h4>
                            <div className="row">
                                <div className="col-md-6 mt-2">
                                    <label for="titles" class="hw-form-label form-label">Anrede</label>
                                    <select className="form-select hw-form-control" id="titles" name="titles" onChange={((e) => formControl())}>
                                        <option value="" hidden>Bitte wählen Sie aus...</option>
                                        <option value="Frau">Frau</option>
                                        <option value="Herr">Herr</option>
                                        <option value="Divers">Divers</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="hw-form-label form-label" for="vorname">Vorname:<strong class="required-star">*</strong></label>
                                        <input className="form-control hw-form-control" name="vorname" id="vorname" placeholder="Vorname" onKeyUp={((e) => formControl())} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="hw-form-label form-label" for="Nachname">Nachname:<strong class="required-star">*</strong></label>
                                        <input className="form-control hw-form-control" name="nachname" id="nachname" placeholder="Nachname" onKeyUp={((e) => formControl())} />
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="hw-form-label form-label" for="Telefon">Telefon:<strong class="required-star">*</strong></label>
                                        <input className="form-control hw-form-control" name="telefon" id="telefon" placeholder="Telefonnummer" onKeyUp={((e) => formControl())} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="hw-form-label form-label" for="E-Mail">E-Mail:<strong class="required-star">*</strong></label>
                                        <input className="form-control hw-form-control" name="email" id="email" placeholder="E-Mail" onKeyUp={((e) => formControl())} />
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="hw-form-label form-label" for="Land">Unternehmen:</label>
                                        <input className="form-control hw-form-control" name="unternehmen" id="unternehmen" placeholder="Firma" onKeyUp={((e) => formControl())} />
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="hw-form-label form-label" for="Land">Straße:</label>
                                        <input className="form-control hw-form-control" name="strabe" id="strabe" placeholder="Straße und Hausnummer" onKeyUp={((e) => formControl())} />
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="hw-form-label form-label" for="Postleitzahl">Postleitzahl:<strong class="required-star">*</strong></label>
                                        <input className="form-control hw-form-control" name="postleitzahl" id="postleitzahl" placeholder="Postleitzahl" onKeyUp={((e) => formControl())} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="hw-form-label form-label" for="Ort">Ort:<strong class="required-star">*</strong></label>
                                        <input className="form-control hw-form-control" name="ort" id="ort" placeholder="Ort" onKeyUp={((e) => formControl())} />
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="hw-form-label form-label" for="Land">Land:</label>
                                        <input className="form-control hw-form-control" name="land" id="land" placeholder="Deutschland" onKeyUp={((e) => formControl())} />
                                    </div>
                                </div>
                            </div>

                            {props.data.eventTops.length > 0 ?
                                <div className="row">
                                    <h4 className="hw-table-subtitle">Anmeldeoption</h4>
                                    <div className="col-md-12">
                                        {props.data.eventTops.map((eventTop, i) => {
                                            const inputValue = eventTop['twdocid'] + "#" + eventTop['flfilingsubject'];
                                            const labelValue = eventTop['flfilingsubject']

                                            return (
                                                <div className="form-group">
                                                    <input className="form-control form-check-input hw-checkbox hw-form-control" name='eventTop[]' value={inputValue} type="checkbox" />
                                                    <label className="hw-form-label form-check-label" for="eventTop">{labelValue}</label>
                                                </div>)
                                        })}



                                    </div>
                                </div> : ''}

                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="hw-form-label form-label" for="Land">Ihre Nachricht:</label>
                                        <textarea class="form-control" id="ihre" name="ihre" rows="5" placeholder="Anmerkungen und Wünsche bitte hier eintragen"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-5">
                                <div className="button-field">
                                    <a href="javascript:history.back()" className="btn btn-secondary hw-back-button"><span><i class="bi bi-arrow-left"></i>&nbsp;&nbsp;Zurück</span></a>
                                    <button className="btn btn-primary hw-register-button" disabled={true} type='submit' name='submit' id='submit' style={{ float: "right" }} ><span><i class="bi bi-arrow-right"></i>&nbsp;&nbsp;Jetzt Anmelden</span></button>
                                </div>
                            </div>
                        </div></form>
                </div>
            )
        }
    }
})

//A function prepared to provide a smoother UI by organising the address array in the API.

function addressOrganisator(address) {

    let newAddress = address.replace(/#/g, ' ');

    return newAddress;
}
//A function prepared to provide a smoother UI by organising the date array in the API.
function dateOrganisator(date) {
    var dateFormat = new Date(date);

    const monthName = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]

    var newDate = dateFormat.getDate() + " " + monthName[dateFormat.getMonth()] + " " + dateFormat.getFullYear();
    return newDate;

}

//A Function for Check Form Input

